import {
    dateFormatter
} from '@/assets/js/util';

function filterDate(val, format) {
    if (val == 'NaN') {
        return '--';
    } else if (val) {
        return dateFormatter(val * 1000, format);
    } else {
        return '--';
    }
}

function filterFixed(val, fixed = 1, empty) {
    let zero = 0;

    if (!val) {
        return empty ? empty : zero.toFixed(fixed);
    }
    let num = parseFloat(val);

    if (num == 0) {
        return empty ? empty : zero.toFixed(fixed);
    }
    return num.toFixed(fixed);
}

function percentTextFilter(val) {
    if (val <= 1) {
        return '前1%';
    }
    if (val <= 2) {
        return '前2%';
    }
    if (val <= 5) {
        return '前5%';
    }
    if (val <= 10) {
        return '前10%';
    }
    if (val <= 20) {
        return '前20%';
    }
    if (val <= 30) {
        return '前30%';
    }
    if (val <= 50) {
        return '前50%';
    }
    return '大于前50%';
}

export {
    filterDate,
    filterFixed,
    percentTextFilter
};



// WEBPACK FOOTER //
// ./src/assets/js/filters.js